module.exports = __webpack_public_path__ + "img/installed_capacity_per_country_recent.efc7bcc1.png";